import React, { type FC } from 'react';
import { formatNumberWithCommas } from '../../../utility/utility';
import { DropdownChangeEvent } from 'primereact/dropdown';
import { Dropdown } from 'primereact/dropdown';
import ClearButton from '../../common/ClearButton';
import { UserValuationType } from '../../../utility/types';

type ValuationsUserInputProps = {
  userSelectedValuationType: UserValuationType;
  inputValue: number;
  setInputValue: Function;
  setUserSelectedValuationType: Function;
  handleResetUserInput: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
};

const inputOptions: UserValuationType[] = [
  UserValuationType.ValuationAmount,
  UserValuationType.DollarPerSqFt,
];
const ValuationsUserInput: FC<ValuationsUserInputProps> = ({
  userSelectedValuationType,
  setUserSelectedValuationType,
  setInputValue,
  inputValue,
  handleResetUserInput,
  inputRef,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputNumber = Number(e.target.value.replace(/,/g, ''));
    // Only allow numbers
    if (!isNaN(inputNumber)) {
      setInputValue(inputNumber);
      // Ensure input stays focused after value update
      if (inputRef.current) {
        // Defer focus reset to after render cycle
        setTimeout(() => {
          inputRef.current?.focus();
        }, 50);
      }
    }
  };

  return (
    <div
      id="valuations-user-input-container"
      className="flex align-middle items-center justify-center mx-2 my-5 z-50 "
    >
      <Dropdown
        id="valuations-dropdown"
        pt={{
          checkIcon: {
            style: {
              marginLeft: '0px',
              marginRight: '4px',
            },
          },
          input: {
            style: {
              fontSize: '12px',
              alignContent: 'center',
              paddingLeft: '2px',
              paddingRight: '2px',
              width: '125px',
              backgroundColor: '#ffffff',
            },
          },
          trigger: {
            className: 'w-[20px]',
          },
          panel: {
            style: {
              backgroundColor: '#ffffff',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              boxShadow:
                '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            },
          },
          item: {
            className: 'hover:!bg-indigo-600',
            style: {
              fontSize: '12px',
              padding: '8px 12px',
            },
          },
        }}
        value={userSelectedValuationType}
        onChange={(e: DropdownChangeEvent) => {
          setUserSelectedValuationType(e.value);
          setInputValue(0);
        }}
        options={inputOptions}
        optionLabel="name"
        className="max-w-[200px]"
        checkmark={true}
      />
      <div
        id="valuations-input-container"
        className="flex justify-center items-center align-middle"
      >
        <input
          id="valuations-input"
          ref={inputRef}
          type="text"
          value={inputValue != null ? formatNumberWithCommas(inputValue) : ''}
          placeholder="-"
          onChange={handleChange}
          className=" text-sm rounded-md border border-gray-300 shadow-x ml-3 w-[145px]"
        />
        <ClearButton
          handleClearInput={handleResetUserInput}
          className="border-5 border-red-600"
        />
      </div>
    </div>
  );
};

export default ValuationsUserInput;
